/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import SmartTagService from '../../service/smartTag.js';
import WyUtils from '../../library/wy-utils.js';
import WyFilter from '../../library/wy-filter.js';
import moment from 'moment';

const state = {
  
};

const getters = {
  
};

const mutations = {
  
};

const actions = {
  async fetchChatFilters({ getters, dispatch, rootState }, { pageName }) {
    return new Promise(async (resolve) => {
      const dataModel = rootState.site.pages[pageName].dataModel;

      if (!getters.localStorage.agentData) {
        dataModel.filters = {
          agentGroups: { label: 'Group', name: 'agentGroups', value: null, type: 'multiSelectCheckbox', placeholder: 'Search agent groups' },
          agentTeams: { label: 'Team', name: 'agentTeams', value: null, type: 'multiSelectCheckbox', placeholder: 'Search teams' },
          agents: { label: 'Agent', name: 'agents', value: null, type: 'multiSelectCheckbox', placeholder: 'Search agents' },
          topics: { label: 'Topics', name: 'topics', value: null, type: 'hidden' },
          speakers: { label: 'Speakers', name: 'speakers', value: '', type: 'checkbox', isRequire: true },
          formId: {label: 'Form', name: 'formId', value: '', type: 'checkbox', isRequire: true},
          contactTypes: { label: 'Contact Types', name: 'contactTypes', value: null, type: 'multiSelectCheckbox', placeholder: 'Search contact types' },
          languages: { label: 'Language', name: 'languages', value: null, type: 'multiSelectCheckbox', placeholder: 'Search languages', category: 'moreFilters' },
          directions: { label: 'Direction', name: 'directions', value: '', type: 'checkbox', isRequire: true, category: 'moreFilters' },
          channels: { label: 'Channels', name: 'channels', value: null, type: 'multiSelectCheckbox', placeholder: 'Search channels', category: 'moreFilters' },
        };
        let res = await SmartTagService.fetchChatFilters(getters.authUser);
        if (res && res.status == 200 && res.data) {
          await dispatch('updateLocalStorage', { key: 'agentData', data: {
            agentGroups: res.data.agentGroups,
            agentTeams: res.data.agentTeams,
            agents: res.data.agents
          }});
          // date limits
          if (res.data.dateLimits && res.data.dateLimits.length > 0) {
            dataModel.dateMin = res.data.dateLimits[0].firstDate;
            dataModel.dateMax = res.data.dateLimits[0].lastDate;
          }

          // agentGroups list
          if (dataModel.filters.agentGroups) {
            dataModel.filters.agentGroups.dataSource = (res.data.agentGroups || []).map((item) => {
              return { key: item.groupId, label: item.groupName?item.groupName:''};
            });
            dataModel.filters.agentGroups.dataSource.sort((a, b) => a.label.localeCompare(b.label))
            dataModel.filters.agentGroups.dataSource.unshift({ key: 'all', label: 'All' });
          }

          // agentTeams list
          if (dataModel.filters.agentTeams) {
            dataModel.filters.agentTeams.dataSource = (res.data.agentTeams || []).map((item) => {
              return { key: item.teamId, label: item.teamName?item.teamName:'', groupId: item.groupId };
            });
            dataModel.filters.agentTeams.dataSource.sort((a, b) => a.label.localeCompare(b.label))
            dataModel.filters.agentTeams.dataSource.unshift({ key: 'all', label: 'All' });
          }

          // agents list
          if (dataModel.filters.agents) {
            dataModel.filters.agents.dataSource = (res.data.agents || []).map((item) => {
              return { key: item.agentId, label: item.agentName?item.agentName:'', teamId: item.teamId, groupId: item.groupId };
            });
            dataModel.filters.agents.dataSource.sort((a, b) => a.label.localeCompare(b.label))
            dataModel.filters.agents.dataSource.unshift({ key: 'all', label: 'All' });
          }
          // direction list
          //mockdata: 
          res.data.directions = [
            {
              "direction": "inbound"
            },
            {
              "direction": "outbound"
            }
          ]
          res.data.speakers = []
          if (dataModel.filters.directions) {
            const directionsMap = getters.authUser.config.app.configs.directionsMapping || {};
            
            // const directionsMap = getters.authUser.config.app.configs.directionsMapping || {'all': "All"};
            dataModel.filters.directions.dataSource = (res.data.directions || []).map((item) => {
              return { key: item.direction, label: directionsMap[item.direction] && directionsMap[item.direction] != '' ? directionsMap[item.direction] : WyUtils.toCamelCase(item.direction) };
            });
            dataModel.filters.directions.dataSource.unshift({ key: '', label: 'All' });
            dataModel.filters.directions.value = '';
          }
          if (dataModel.filters.speakers) {
            const speakersMap = getters.authUser.config.app.configs.directionsMapping || {};
            dataModel.filters.speakers.dataSource = (res.data.speakers || []).map((item) => {
              return { key: item.speakers, label: speakersMap[item.speakers] && speakersMap[item.speakers] != '' ? speakersMap[item.speakers] : WyUtils.toCamelCase(item.speakers) };
            });
            dataModel.filters.speakers.dataSource.unshift({ key: 'any', label: 'All' });
            dataModel.filters.speakers.dataSource.push({ key: 'agent', label: 'Agent Only' });
            dataModel.filters.speakers.dataSource.push({ key: 'customer', label: 'Customer Only' });
            dataModel.filters.speakers.dataSource.push({ key: 'both', label: 'Agent & Customer' });
            dataModel.filters.speakers.value = 'any';
          }
          if (dataModel.filters.formId) {
            dataModel.filters.formId.dataSource = res.data.formList
            dataModel.filters.formId.value = (res.data.formList && res.data.formList.length > 0) ? res.data.formList[0].formId : ''
          }
          // languages list
          //mockdata: 
          // res.data.languages = [
          //   {languageId: 'en', languageName: 'English'},
          //   {languageId: 'fr', languageName: 'French'}
          // ]
          if (dataModel.filters.languages) {
            dataModel.filters.languages.dataSource = (res.data.languages || []).map((item) => {
              return { key: item.languageId, label: item.languageName };
            });
            dataModel.filters.languages.dataSource.sort((a, b) => a.label.localeCompare(b.label))
            if(dataModel.filters.languages.dataSource.length > 1) {
              dataModel.filters.languages.dataSource.unshift({ key: 'all', label: 'All' });
            }
            else if(dataModel.filters.languages.dataSource.length == 1){
              // dataModel.filters.languages.value = [dataModel.filters.languages.dataSource[0].key];
              dataModel.filters.languages.value = [];
            }
            else {
              dataModel.filters.languages.value = [];
            }
          }
          if (dataModel.filters.contactTypes) {
            dataModel.filters.contactTypes.dataSource = (res.data.contactTypes || []).map((item) => {
              return { key: item.contactTypeKey, label: item.contactTypeName };
            });
            dataModel.filters.contactTypes.dataSource.sort((a, b) => a.label.localeCompare(b.label))
            if(dataModel.filters.contactTypes.dataSource.length > 1) {
              dataModel.filters.contactTypes.dataSource.unshift({ key: 'all', label: 'All' });
            }
            else if(dataModel.filters.contactTypes.dataSource.length == 1){
              // dataModel.filters.contactTypes.value = [dataModel.filters.contactTypes.dataSource[0].key];
              dataModel.filters.contactTypes.value = [];
            }
          }
          if (dataModel.filters.channels) {
            dataModel.filters.channels.dataSource = (res.data.channels || []).map((item) => {
              return { key: item.channelKey, label: item.channelName };
            });
            dataModel.filters.channels.dataSource.sort((a, b) => a.label.localeCompare(b.label))
            if(dataModel.filters.channels.dataSource.length > 1) {
              dataModel.filters.channels.dataSource.unshift({ key: 'all', label: 'All' });
            }
            // comment out this due to this ticket issue  1078014
            // else if(dataModel.filters.channels.dataSource.length == 1){
            //   // dataModel.filters.channels.value = [dataModel.filters.channels.dataSource[0].key];
            //   dataModel.filters.channels.value = [];
            // }
          }

          // set iframe selected filters
          WyFilter.setIFrameSelectedFilters(dataModel);
          
          // reset appliedFiltersCounter to 0
          dataModel.appliedFiltersCounter = 0;

          await dispatch('initFilterOriginalSource');
          resolve();
        } else {
          resolve();
        }
      } else {
        resolve();
      }
    });
  },

  async fetchSmartTagsDashboard({ commit, getters }, options) {
    if (getters.dataModel.dateStart && getters.dataModel.dateEnd) {
      let results = [];

      let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
      let res = await SmartTagService.fetchSmartTagsDashboard(getters.authUser, options, payload);

      if (getters.moreFiltersChanged <= 0) {
        if (getters.dataModel.dateHasChanged) {
          getters.dataModel.dateHasChanged = false;
        }
      }

      // if not cached, process the following
      if (!(res === true)) {
        if (res && res.status === 200 && res.data.results) {
          let resultsA = res.data.results;
          //let resultsB = res.data.resultsCompare;
          let sumTotalVolume = resultsA.reduce((total, item) => {
            return total + item.totalVolume;
          }, 0);
          resultsA.forEach((item) => {
            item.isSelected = false;
            item.isEditing = false;

            if (item.mergedTopics && item.mergedTopics.length > 1) {
              item.smartTagNameWithCount = item.smartTagName + ` (${item.mergedTopics.length})`; // showing number of merged topics
            } else {
              item.smartTagNameWithCount = item.smartTagName;
            }

            item.numOfDaysInRange = getters.dataModel.dateRangeInDays;
            item.volumePercent = ((item.totalVolume / sumTotalVolume) * 100).toFixed(2); // TODO: calculate the percent
            item.volumePercentNum = (item.totalVolume / sumTotalVolume) * 100;
            generateSmartTagsData(item, getters.xnumber);
            generatAlertIconData(item);
            results.push(item);
          });
          let totalSmartTags = 0;
          if (res.data.totalSmartTags) {
            totalSmartTags = res.data.totalSmartTags;
          }
          commit('updateTableModelResult', {
            results: results,
            totalRecs: results.length,
            totalNumber: totalSmartTags,
            totalPages: 1,
          });

          return true;
        }
        return false;
      } else {
        return true;
      }
    }
  },

  fetchSmartTagTrend({ getters }, {item}) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.tagId = item.tagId;
    payload.smartTagUniqueKey = item.smartTagUniqueKey;
    return SmartTagService.fetchSmartTagTrend(getters.authUser, payload);
  },

  fetchContactsDetails({ getters }, data) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.tagId = data.tagId;
    payload.smartTagUniqueKey = data.smartTagUniqueKey;
    payload.topicDisplayName = data.topicDisplayName;
    if (data.pageNo) payload.pageNo = data.pageNo;
    if (data.pageSize) payload.pageSize = data.pageSize;

    if (data.date) {
      payload.dateStart = data.date;
      payload.dateEnd = data.date;
    }
    payload.from = data.from;
    return SmartTagService.fetchContactsDetails(getters.authUser, payload);
  },

  fetchAssociatedTopicContacts({ getters }, data) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.tagId = data.tagId;
    payload.smartTagUniqueKey = data.smartTagUniqueKey;
    payload.topics = data.topics;
    payload.topicDisplayName = data.topicDisplayName;
    if (data.pageNo) payload.pageNo = data.pageNo;
    if (data.pageSize) payload.pageSize = data.pageSize;

    if (data.date) {
      payload.dateStart = data.date;
      payload.dateEnd = data.date;
    }
    payload.from = data.from;
    return SmartTagService.fetchAssociatedTopicContacts(getters.authUser, payload);
  },

  fetchAssociatedTopics({ getters }, data) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.tagId = data.tagId;
    payload.smartTagUniqueKey = data.smartTagUniqueKey;
    if (data.date) {
      payload.dateStart = data.date;
      payload.dateEnd = data.date;
    }
    payload.from = data.from;
    return SmartTagService.fetchAssociatedTopics(getters.authUser, payload);
  },

  fetchAssociatedTopicPhraseHitCategories({ getters }, data) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.tagId = data.tagId;
    payload.smartTagUniqueKey = data.smartTagUniqueKey;
    if (data.date) {
      payload.dateStart = data.date;
      payload.dateEnd = data.date;
    }
    payload.from = data.from;
    return SmartTagService.fetchAssociatedTopicPhraseHitCategories(getters.authUser, payload);
  },
  fetchAssociatedTopicPhraseHitByCategoryName({ getters }, data) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.tagId = data.tagId;
    payload.smartTagUniqueKey = data.smartTagUniqueKey;
    payload.category = data.categoryName;
    if (data.date) {
      payload.dateStart = data.date;
      payload.dateEnd = data.date;
    }
    return SmartTagService.fetchAssociatedTopicPhraseHitByCategoryName(getters.authUser, payload);
  },
  
  
  fetchAssociatedTopicPhraseHitContacts({ getters }, data) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.tagId = data.tagId;
    payload.smartTagUniqueKey = data.smartTagUniqueKey;
    payload.category = data.categoryName;
    payload.phrase = data.phraseName;
    if (data.pageNo) payload.pageNo = data.pageNo;
    if (data.pageSize) payload.pageSize = data.pageSize;
    if (data.date) {
      payload.dateStart = data.date;
      payload.dateEnd = data.date;
    }
    return SmartTagService.fetchAssociatedTopicPhraseHitContacts(getters.authUser, payload);
  },
};

function convertToChangeValue(changeValue) {
  if (changeValue > 0) return '+';
  else if (changeValue < 0) return '-';
  else return '';
}

function generateSmartTagsData(item, xnumber) {
  let noneDataSorting = -1000000;

  // volume
  item.totalVolumeDMValue = item.totalVolume != null ? item.totalVolume * xnumber : item.totalVolume;
  if (item.totalVolumeCompare) {
    item.totalVolumeCompareDMValue = item.totalVolumeCompare != null ? item.totalVolumeCompare * xnumber : item.totalVolumeCompare;
    item.volumeChangeWithoutAbs = (item.totalVolume - item.totalVolumeCompare) / item.totalVolumeCompare;
    item.volumeChange = Math.abs(item.volumeChangeWithoutAbs);
    item.volumeChangeDisplay = convertToChangeValue(item.volumeChangeWithoutAbs) + (item.volumeChange * 100).toFixed(2);
    item.volumeChangePercent = (item.volumeChange * 100).toFixed(2);
    item.volumeChangeTooltip = generatTooltipsMsg(item.totalVolumeCompare != null ? item.totalVolumeCompare * xnumber : item.totalVolumeCompare, item.numOfDaysInRange, false);
  } else {
    item.volumeChange = null;
    item.volumeChangeWithoutAbs = noneDataSorting;
    item.volumeChangeDisplay = null;
  }
  // agent handle time
  item.avgAgentHandleTimeDisplay = item.avgAgentHandleTime >= 0 ? WyUtils.toNiceTimeFormat(item.avgAgentHandleTime * 60) : item.avgAgentHandleTime;
  if (item.avgAgentHandleTimeCompare && item.avgAgentHandleTimeCompare > -1) {
    item.avgAgentHandleTimeCompareDisplay = WyUtils.toNiceTimeFormat(item.avgAgentHandleTimeCompare * 60);
    item.avgAgentHandleTimeChangeWithoutAbs = (item.avgAgentHandleTime - item.avgAgentHandleTimeCompare) / item.avgAgentHandleTimeCompare;
    item.avgAgentHandleTimeChange = Math.abs(item.avgAgentHandleTimeChangeWithoutAbs);
    item.avgAgentHandleTimeChangeDisplay = convertToChangeValue(item.avgAgentHandleTimeChangeWithoutAbs) + (item.avgAgentHandleTimeChange * 100).toFixed(2);
    item.avgAgentHandleTimeChangePercent = (item.avgAgentHandleTimeChange * 100).toFixed(2);
    item.avgAgentHandleTimeChangeTooltip = generatTooltipsMsg(item.avgAgentHandleTimeCompareDisplay, item.numOfDaysInRange, false);
  } else {
    item.avgAgentHandleTimeCompareDisplay = null;
    item.avgAgentHandleTimeChange = null;
    item.avgAgentHandleTimeChangeWithoutAbs = noneDataSorting;
    item.avgAgentHandleTimeChangeDisplay = null;
  }

  // avg response time
  item.avgAgentResponseTimeDisplay = WyUtils.toNiceTimeFormat(item.avgAgentResponseTime * 60);
  if (item.avgAgentResponseTimeCompare) {
    item.avgAgentResponseTimeCompareDisplay = WyUtils.toNiceTimeFormat(item.avgAgentResponseTimeCompare * 60);
    item.avgAgentResponseTimeChangeWithoutAbs = (item.avgAgentResponseTime - item.avgAgentResponseTimeCompare) / item.avgAgentResponseTimeCompare;
    item.avgAgentResponseTimeChange = Math.abs(item.avgAgentResponseTimeChangeWithoutAbs);
    item.avgAgentResponseTimeChangeDisplay = convertToChangeValue(item.avgAgentResponseTimeChangeWithoutAbs) + (item.avgAgentResponseTimeChange * 100).toFixed(2);
    item.avgAgentResponseTimeChangePercent = (item.avgAgentResponseTimeChange * 100).toFixed(2);
    item.avgAgentResponseTimeChangeTooltip = generatTooltipsMsg(item.avgAgentResponseTimeCompareDisplay, item.numOfDaysInRange, false);
    item.avgAgentResponseTimeChangeWithoutAbsNum = parseFloat(item.avgAgentResponseTimeChangeWithoutAbs);
  } else {
    item.avgAgentResponseTimeCompareDisplay = null;
    item.avgAgentResponseTimeChange = null;
    item.avgAgentResponseTimeChangeWithoutAbs = noneDataSorting;
    item.avgAgentResponseTimeChangeWithoutAbsNum = noneDataSorting;
    item.avgAgentResponseTimeChangeDisplay = null;
  }

  // median response time
  item.medianResponseTimeDisplay = WyUtils.toNiceTimeFormat(item.medianResponseTime * 60);
  if (item.medianResponseTimeCompare) {
    item.medianResponseTimeCompareDisplay = WyUtils.toNiceTimeFormat(item.medianResponseTimeCompare * 60);
    item.medianResponseTimeChangeWithoutAbs = (item.medianResponseTime - item.medianResponseTimeCompare) / item.medianResponseTimeCompare;
    item.medianResponseTimeChange = Math.abs(item.medianResponseTimeChangeWithoutAbs);
    item.medianResponseTimeChangeDisplay = convertToChangeValue(item.medianResponseTimeChangeWithoutAbs) + (item.medianResponseTimeChange * 100).toFixed(2);
    item.medianResponseTimeChangeTooltip = generatTooltipsMsg(item.medianResponseTimeCompare, item.numOfDaysInRange, false);
  } else {
    item.medianResponseTimeCompareDisplay = null;
    item.medianResponseTimeChange = null;
    item.medianResponseTimeChangeWithoutAbs = noneDataSorting;
    item.medianResponseTimeChangeDisplay = null;
  }
}

function generatAlertIconData(item) {
  item.alertsIcon = {
    icon: '',
    value: 0,
  };
  // item.dateFirstFound = '2020-11-10';
  if (item.dateFirstFound && item.dateFirstFound != '') {
    item.dateFirstFoundSorting = moment(item.dateFirstFound, 'YYYY-MM-DD').format('X');
    item.dateFirstFound = WyUtils.formatDate(item.dateFirstFound);
  }
}

function generatTooltipsMsg(compareValue, numOfDaysInRange, isPercentage) {
  let message = '';
  let percentage = '';
  if (isPercentage) {
    percentage = '%';
  }
  message = `Compared to ${compareValue + percentage} over the previous ${numOfDaysInRange} days.`;
  return message;
}

export default {
  state,
  getters,
  mutations,
  actions,
};
